import { useSelector } from "react-redux";

export default function useAuth() {
  const auth = useSelector(({ auth }) => auth);

  return auth;
}
